import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLanguage } from "@/contexts/LanguageContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  const { lang } = useLanguage();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/public/privacy").then((r) => setData(r.data)); }, []);
  if (!data) return <main className="min-h-[calc(100vh-4rem)] grid place-items-center text-slate-500">…</main>;
  const items = lang === "ar" ? data.content_ar : data.content_en;
  const title = lang === "ar" ? data.title_ar : data.title_en;
  return (
    <main className="min-h-[calc(100vh-4rem)] px-6 py-12" data-testid="privacy-page">
      <div className="mx-auto max-w-3xl">
        <h1 className="font-heading text-4xl font-bold text-slate-900 mb-4 text-start">{title}</h1>
        <p className="text-xs text-slate-500 text-start mb-8">Updated: {data.updated_at}</p>
        <Card className="p-8 border border-slate-200 shadow-none space-y-5">
          {items.map((p, i) => (
            <p key={i} className="text-sm text-slate-700 leading-relaxed text-start">{p}</p>
          ))}
        </Card>
        <Alert className="mt-6 bg-slate-50 border-slate-200">
          <AlertDescription className="text-xs text-slate-600 text-start">
            {lang === "ar" ? "للتواصل أو حذف الحساب: " : "Contact or account deletion: "}
            <a className="text-blue-600 hover:underline" href={`mailto:${data.support.email}`}>{data.support.email}</a>
            {" · WhatsApp "}
            <a className="text-blue-600 hover:underline" href={`https://wa.me/${data.support.whatsapp.replace(/[^\d]/g,'')}`}>{data.support.whatsapp}</a>
          </AlertDescription>
        </Alert>
        <div className="mt-8">
          <Link to="/"><Button variant="outline">{lang === "ar" ? "العودة" : "Back"}</Button></Link>
        </div>
      </div>
    </main>
  );
}
